import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-361a5c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:tw-leading-[100%] md:tw-text-[22px] tw-text-[18px] tw-text-[#211F58] md:tw-mb-[0px] tw-mb-[10px] tw-w-full tw-items-center tw-flex tw-justify-between" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[10px]" }
const _hoisted_3 = {
  class: "tw-font-semibold",
  "data-cy": "vendor-assess-template-title-page"
}
const _hoisted_4 = { class: "tw-items-center tw-flex tw-justify-center" }
const _hoisted_5 = {
  key: 0,
  class: "tw-h-[38px] tw-w-[38px]"
}
const _hoisted_6 = {
  key: 1,
  class: "tw-h-[38px] tw-w-[38px]"
}
const _hoisted_7 = {
  key: 2,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}
const _hoisted_8 = {
  id: "popover-vendor-assessments-create-header-option-wrap",
  class: "tw-w-[46px] tw-h-[44px] tw-items-center tw-flex tw-justify-center",
  style: {"border-radius":"6px","border":"1px solid var(--UI-rule, #eff0f1)","background":"var(--UI-white, #fff)","box-shadow":"0px 0px 4px 0px rgba(0, 0, 0, 0.05)"}
}
const _hoisted_9 = { class: "tw-flex tw-gap-[20px] tw-w-full md:tw-flex-row tw-flex-col" }
const _hoisted_10 = {
  id: "vendor-assess-template-status",
  class: "tw-flex-1"
}
const _hoisted_11 = {
  key: 0,
  class: "custom-global-skeleton tw-bg-[#ffffff] !tw-max-w-[2000px] tw-min-w-0 tw-h-[112px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_12 = {
  id: "vendor-assess-template-contributors",
  class: "tw-flex-1"
}
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-bg-[#ffffff] !tw-max-w-[2000px] tw-min-w-0 tw-h-[112px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_14 = { class: "tw-flex tw-gap-[20px] tw-w-full md:tw-flex-row tw-flex-col" }
const _hoisted_15 = {
  id: "vendor-assess-template-details",
  class: "tw-flex tw-flex-1 tw-p-5 tw-bg-white tw-rounded-md tw-flex-col tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_16 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-mb-[15px]" }
const _hoisted_17 = {
  key: 0,
  class: "custom-global-skeleton tw-bg-[#ffffff] !tw-max-w-[800px] tw-min-w-0 tw-h-[122px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = {
  id: "vendor-assess-template-notes",
  class: "tw-flex tw-flex-1 tw-p-5 tw-bg-white tw-rounded-md tw-flex-col tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_20 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-[600] tw-leading-[130%] tw-mb-[15px]" }
const _hoisted_21 = {
  key: 0,
  class: "custom-global-skeleton tw-bg-[#ffffff] !tw-max-w-[800px] tw-min-w-0 tw-h-[198px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_22 = ["placeholder"]

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import PopoverAssessment from "../assessment/popoverAssessment.vue";
import StatusCard from "../assessments/statusCard.vue";
import ContributorsCard from "../assessments/contributorsCard.vue";
import BaseInput from "../common/form/baseInput.vue";
import { helpers, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import ChevronsIconButton from "../svgs/chevronsIconButton.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  createRequestedTemplate,
  updateRequestedTemplate,
  updateRequestedTemplateDetail,
} from "@/services/vendor";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import store from "@/store";
import userService from "@/services/user/userService";
import get from "lodash/get";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import SuccessAnimation from "../../assets/animation/success.json";
import ErrorAnimation from "../../assets/animation/error.json";
import { IModalMessage } from "@/interfaces/common/common";
import { ARE_YOU_SURE_TYPES, MODAL_NAME } from "@/utils/constants";
import router from "@/router";
import CustomDropDownItem from "../common/customDropDownItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorCreateTemplate',
  props: {
  isEdit: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  templateId: {
    type: String,
    default: null,
  },
},
  emits: ["handleUpdateData", "isCallUpdate"],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;



const form = ref({
  templateAddedByUserId: "",
  templateName: "",
  templateDescription: "",
  templateNotes: "",
  templateDateAdded: "",
  templateDateLastUpdated: "",
});

const templateIdRef = ref(props.templateId);

const isLoadingGetContributors = ref(false);

const isCallAPI = ref(false);
const isSuccess = ref(false);
const isFail = ref(false);

const userContributor: any = ref([]);

const isUpdateTemplateNotes = ref(false);
const isUpdateTemplateDescription = ref(false);
const isUpdateTemplateName = ref(false);

const focusOut = () => {
  // if (
  //   form.value.templateName === currentPrams.name &&
  //   form.value.templateDescription === currentPrams.description &&
  //   form.value.templateNotes === currentPrams.notes
  // )
  //   return;

  const focusEvent = event as FocusEvent;
  if (
    focusEvent.relatedTarget &&
    (focusEvent.relatedTarget as HTMLElement).classList.contains("no-focus-out")
  ) {
    return;
  } else if (
    isUpdateTemplateName.value &&
    (form.value.templateName !== currentPrams.name || props.isEdit)
  ) {
    createTemplate();
  } else if (
    isUpdateTemplateDescription.value &&
    templateIdRef.value &&
    form.value.templateDescription !== currentPrams.description &&
    form.value.templateDescription !== null
  ) {
    createTemplate();
  } else if (
    isUpdateTemplateNotes.value &&
    templateIdRef.value &&
    form.value.templateNotes !== currentPrams.notes
  ) {
    createTemplate();
  }
};

let currentPrams: any = {};
const requestedTemplateDetailByChecklistId = computed(() => {
  const data = store.state.Vendor.checklistRequestedTemplateDetail[0];
  if (data) {
    currentPrams = {
      name: data.templateName,
      description: data.templateDescription ? data.templateDescription : "",
      notes: data.templateNotes !== null ? data.templateNotes : "",
    };
  }
  return data;
});

const getUserContributor = async (userIds) => {
  isLoadingGetContributors.value = true;
  const getUserData = async (user) => {
    if (!user) return;
    const res = await userService.getUserProfile(user);
    const data: any = get(res, "data.data", {} as any);
    return {
      userId: data.userId,
      firstName: data.firstName,
      lastName: data.lastName,
      avatarImageId: data.avatar.avatarImageFileId
        ? data.avatar.avatarImageFileId
        : "",
    };
  };
  userContributor.value = await Promise.all(userIds.map(getUserData));
  isLoadingGetContributors.value = false;
};

watch(
  () => requestedTemplateDetailByChecklistId.value,
  (value) => {
    if (value) {
      let checklistUserContributor: string[] = [];
      if (value.templateAddedByUserId) {
        checklistUserContributor.push(value.templateAddedByUserId);
      } else if (
        value.templateLastUpdatedByUserId &&
        value.templateLastUpdatedByUserId !== value.templateAddedByUserId
      ) {
        checklistUserContributor.push(value.templateLastUpdatedByUserId);
      }
      getUserContributor(checklistUserContributor);
      form.value.templateAddedByUserId = value.templateAddedByUserId;
      form.value.templateName = value.templateName;
      form.value.templateDescription = value.templateDescription;
      form.value.templateNotes = value.templateNotes ? value.templateNotes : "";
      form.value.templateDateAdded = value.templateDateAdded;
      form.value.templateDateLastUpdated = value.templateDateUpdated
        ? value.templateDateUpdated
        : value.templateDateAdded;
    }
  },
);



const rules = {
  templateName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  templateDescription: {
    // required: helpers.withMessage(
    //   () => getComponentUiText("app-setting-org-detail-required-fields-1"),
    //   required,
    // ),
  },
};
const v$ = useVuelidate(rules, form.value as any);

onMounted(() => {
  eventEmitter.on(EmitterEvents.CREATE_VENDOR_TEMPLATE, createTemplate);
});

onUnmounted(() => {
  eventEmitter.off(EmitterEvents.CREATE_VENDOR_TEMPLATE);
});

watch(
  () => templateIdRef.value,
  () => {
    store.commit("Vendor/SET_TEMPLATE_EDIT_ID", templateIdRef.value ?? null);
  },
  {
    immediate: true,
  },
);

const createTemplate = async () => {
  if (templateIdRef.value) {
    isCallAPI.value = true;
    store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
    const parms = {
      name: form.value.templateName,
      description: form.value.templateDescription,
      notes: form.value.templateNotes,
    };
    const changedParams = Object.fromEntries(
      Object.entries(parms).filter(([key, value]) => {
        return value !== currentPrams[key] && value !== null;
      }),
    );

    try {
      await v$.value.$validate();
      if (v$.value.$invalid) {
        emits("isCallUpdate", false);
        return;
      }

      const res = await updateRequestedTemplateDetail({
        templateId: templateIdRef.value,
        params: changedParams,
      });
      const data = get(res, "data.data", {} as any);
      if (res.status === 200) {
        showSuccessToast(
          getComponentUiText(
            "app-assessment-vendor-update-templates-successfully-1",
          ),
        );
        // form.value.templateName = "";
        // form.value.templateDescription = "";
        // form.value.templateNotes = "";
        store.commit("Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", [
          data,
        ]);
        emits("isCallUpdate", true);
        isSuccess.value = true;
        setTimeout(() => {
          isSuccess.value = false;
        }, 2000);
        v$.value.$reset();
      }
    } catch (error) {
      isFail.value = true;
      setTimeout(() => {
        isFail.value = false;
      }, 1500);
      showErrorAPI(error, Vendor.requestedTemplateDetail);
      emits("isCallUpdate", false);
    } finally {
      isCallAPI.value = false;
      isUpdateTemplateName.value = false;
      isUpdateTemplateDescription.value = false;
      isUpdateTemplateNotes.value = false;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
    }
  } else {
    isCallAPI.value = true;
    store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
    try {
      await v$.value.$validate();
      if (v$.value.$invalid) {
        emits("isCallUpdate", false);
        return;
      }

      // get order of template
      const templates = store.state.Vendor.checklistRequestedTemplate;
      const order =
        templates && templates.length > 0
          ? templates[templates.length - 1]?.templateOrder + 10
          : 10;
      const res = await createRequestedTemplate({
        name: form.value.templateName,
        description: form.value.templateDescription,
        notes: form.value.templateNotes,
        order,
      });
      const data = get(res, "data.data", {} as any);
      form.value.templateDateAdded = data.templateDateAdded;
      form.value.templateDateLastUpdated = data.templateDateUpdated
        ? data.templateDateUpdated
        : data.templateDateAdded;
      templateIdRef.value = data.templateId;

      if (res.status === 200) {
        showSuccessToast(
          getComponentUiText(
            "app-assessment-vendor-create-templates-successfully-1",
          ),
        );
        // form.value.templateName = "";
        // form.value.templateDescription = "";
        // form.value.templateNotes = "";
        emits("isCallUpdate", true);
        isSuccess.value = true;
        setTimeout(() => {
          isSuccess.value = false;
        }, 2000);
        v$.value.$reset();
        store.commit("Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", [
          data,
        ]);
      }
    } catch (error) {
      isFail.value = true;
      setTimeout(() => {
        isFail.value = false;
      }, 1500);
      showErrorAPI(error, Vendor.postChecklistRequestedTemplate);
      emits("isCallUpdate", false);
    } finally {
      isCallAPI.value = false;
      isUpdateTemplateName.value = false;
      isUpdateTemplateDescription.value = false;
      isUpdateTemplateNotes.value = false;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
    }
  }
};

const validTemplate = async () => {
  await v$.value.$validate();
  if (v$.value.$invalid) {
    emits("isCallUpdate", false);
  } else {
    emits("isCallUpdate", true);
  }
};

const handleUpdateData = () => {
  emits("handleUpdateData", form.value);
};

const isSubmit = computed(() => store.state.Vendor.isShowButton);

const onCreateNewAssessmentUsingTemplate = () => {
  if (!isSubmit.value) {
    createTemplate();
    // eventEmitter.emit(EmitterEvents.CREATE_VENDOR_TEMPLATE);
  }
};

watch(
  () => form.value,
  (value) => {
    if (value.templateName) {
      store.commit("Vendor/SET_IS_EXITS_TEMPLATE_NAME", true);
    } else {
      store.commit("Vendor/SET_IS_EXITS_TEMPLATE_NAME", false);
    }
    if (templateIdRef.value) {
      if (value.templateName && currentPrams.name !== value.templateName) {
        store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
      } else {
        store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
      }
    } else {
      if (
        currentPrams.name === value.templateName &&
        currentPrams.description === value.templateDescription &&
        currentPrams.notes === value.templateNotes
      ) {
        store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
      } else if (!props.isEdit) {
        if (value && value.templateName) {
          store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
        } else {
          store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
        }
      }
    }
  },
  {
    immediate: true,
    deep: true,
  },
);

watch(
  () => form.value.templateNotes,
  (value) => {
    if (v$.value.$invalid || (currentPrams.notes == value && props.isEdit)) {
      isUpdateTemplateNotes.value = false;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
    } else {
      isUpdateTemplateNotes.value = true;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
    }
  },
);

watch(
  () => form.value.templateName,
  (value) => {
    if (v$.value.$invalid || (currentPrams.name == value && props.isEdit)) {
      isUpdateTemplateName.value = false;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
    } else {
      isUpdateTemplateName.value = true;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
    }
  },
  { immediate: true, deep: true },
);

watch(
  () => form.value.templateDescription,
  (value) => {
    if (
      v$.value.$invalid ||
      (currentPrams.description == value && props.isEdit)
    ) {
      isUpdateTemplateDescription.value = false;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", true);
    } else {
      isUpdateTemplateDescription.value = true;
      store.commit("Vendor/SET_IS_SHOW_BUTTON", false);
    }
  },
);

const handleDeleteAssessment = (item: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assess-assessment-modal-delete-template-title-1",
      ),
      description: getComponentUiText(
        "app-assessments-vendor-assessment-description-delete-template-modal-1",
        false,
        { name: item.templateName },
      ),

      list: [],
      buttonText: getComponentUiText(
        "app-settings-domain-verify-modal-delete-button-1",
      ),

      isShowBtnCancel: true,
      buttonRed: true,
      hiddenHelp: false,
      type: ARE_YOU_SURE_TYPES.assessmentTemplateDelete,
    },
    events: {
      "update:data": async () => {
        store.dispatch(
          "LoadingAreYouSureButtonModal/setLoadingRedButton",
          true,
        );
        try {
          const res = await updateRequestedTemplate({
            templateId: item.templateId,
            params: {
              isArchived: true,
            },
          });
          if (res.status === 200) {
            showSuccessToast(
              getComponentUiText(
                "app-assessment-vendor-delete-templates-successfully-1",
              ),
            );
            await store.dispatch("Vendor/fetchRequestedTemplate");
          }
          router.replace({ path: "/assess/vendor/manage" });
        } catch (error) {
          showErrorAPI(error, Vendor.putChecklistRequestedTemplate);
        } finally {
          store.dispatch(
            "LoadingAreYouSureButtonModal/setLoadingRedButton",
            false,
          );
        }
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  eventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
};

const items = [
  {
    text: "app-assess-assessment-modal-delete-template-title-1",
    arrowRed: true,
    action: handleDeleteAssessment,
    status: true,
  },
];

__expose({
  createTemplate,
  validTemplate,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${
      __props.isEdit ? 'background-edit' : 'tw-bg-[#D9EDE2]'
    } tw-relative tw-flex tw-flex-col xl:tw-px-[60px] xl:tw-pt-[41px] xl:tw-pb-[55px] tw-px-[20px] tw-py-[20px] tw-gap-[20px]`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.isEdit
              ? `${_unref(getComponentUiText)(
                  "app-assessment-vendor-edit-template-title-1",
                )}:`
              : _unref(getComponentUiText)(
                  "app-assessment-vendor-create-template-title-1",
                )), 1),
        _withDirectives(_createElementVNode("span", { class: "tw-font-normal tw-leading-[100%]" }, _toDisplayString(form.value.templateName), 513), [
          [_vShow, __props.isEdit]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (isCallAPI.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(LottieAnimation), {
                ref: "anim",
                "animation-data": _unref(ProgressAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : _createCommentVNode("", true),
        (isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(LottieAnimation), {
                ref: "anim",
                "animation-data": _unref(SuccessAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : _createCommentVNode("", true),
        (isFail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(LottieAnimation), {
                ref: "anim",
                "animation-data": _unref(ErrorAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(PopoverAssessment, {
            "id-popover": "popover-vendor-assessments-create-header-option",
            padding: "14px 13px"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
                return _createVNode(CustomDropDownItem, {
                  id: `popover-create-template-item-${index}`,
                  key: `option_create_template_${index}`,
                  "is-show-option": item.status,
                  "id-text": `${item.text}`,
                  "custom-text-class": `tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                item.arrowRed ? 'tw-text-[#F7553C]' : ''
              } tw-whitespace-normal`,
                  "arrow-icon-style": `${
                item.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
              } tw-min-w-[7px]`,
                  padding: 'tw-px-[13px] tw-py-[12px]',
                  "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                  onClick: () => item.action(requestedTemplateDetailByChecklistId.value)
                }, null, 8, ["id", "is-show-option", "id-text", "custom-text-class", "arrow-icon-style", "onClick"])
              }), 64))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (__props.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
          : (_openBlock(), _createBlock(StatusCard, {
              key: 1,
              "is-show-tag": false,
              status: {
            created: form.value.templateDateAdded,
            started: form.value.templateDateLastUpdated,
          },
              class: "!tw-max-w-[2000px] tw-flex-1 !tw-h-[112px] tw-bg-white"
            }, null, 8, ["status"]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (isLoadingGetContributors.value || __props.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
          : (_openBlock(), _createBlock(ContributorsCard, {
              key: 1,
              id: `contributor-card`,
              class: "!tw-max-w-[2000px] tw-flex-1 tw-min-w-0 tw-bg-white",
              "checklist-id": 1,
              "list-contributors": userContributor.value
            }, null, 8, ["list-contributors"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(getComponentUiText)("app-menu-submenu-settings-org-details-1")), 1),
        _createVNode(BaseInput, {
          modelValue: form.value.templateName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.templateName) = $event)),
          validation: _unref(v$).templateName,
          "label-class": `tw-flex tw-items-center tw-h-[14px] sm:tw-mt-[19.5px] tw-mb-[10px] sm:tw-mb-0 tw-text-[#211F58]`,
          "input-class": '!tw-h-[56px]',
          "class-name": `modal-edit-action-step-input !tw-mt-[0px]`,
          "data-cy-id": "vendor-assess-template-title-input",
          container: `tw-mb-5`,
          placeholder: 
            _unref(getComponentUiText)(
              'app-assessment-vendor-template-title-placeholder-1',
            )
          ,
          label: _unref(getComponentUiText)('app-assessment-vendor-template-title-1'),
          "is-skeleton": __props.isLoading,
          "id-focus": `vendor-create-template-template-title`,
          onBlur: _cache[1] || (_cache[1] = 
            () => {
              focusOut();
              _unref(v$).templateName.$validate();
            }
          )
        }, null, 8, ["modelValue", "validation", "placeholder", "label", "is-skeleton"]),
        _createVNode(BaseInput, {
          modelValue: form.value.templateDescription,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((form.value.templateDescription) = $event)),
            _cache[5] || (_cache[5] = 
            (text) => {
              form.value.templateDescription = text;
              handleUpdateData();
            }
          )
          ],
          "class-name": `modal-edit-action-step-input !tw-mt-[0px] !tw-mb-[-7px]`,
          "label-class": `tw-mb-[10px] tw-text-[#231F20] tw-flex tw-items-center tw-h-[41px] sm:tw-mt-[18px]`,
          validation: _unref(v$).templateDescription,
          "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
          label: 
            _unref(getComponentUiText)(
              'app-assessment-vendor-template-description-title-1',
            )
          ,
          "label-tooltip": 
            _unref(getComponentUiText)(
              'app-assessment-vendor-template-description-tooltip-1',
            )
          
        }, {
          default: _withCtx(() => [
            (__props.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17))
              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  id: `vendor-create-template-template-des`,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((form.value.templateDescription) = $event)),
                    _cache[3] || (_cache[3] = 
              (text) => {
                form.value.templateDescription = text;
                handleUpdateData();
              }
            )
                  ],
                  placeholder: 
              _unref(getComponentUiText)(
                'app-assessment-vendor-template-description-placeholder-1',
              )
            ,
                  style: `outline-color : #EFF0F1`,
                  "data-cy": "vendor-assess-template-description-input",
                  class: _normalizeClass([
              isCallAPI.value && isUpdateTemplateDescription.value ? 'tw-pr-[50px]' : ''
            , "tw-relative tw-max-w-[800px] tw-placeholder-[#B7B7B7] auto-expand tw-min-h-[122px] tw-w-[100%] tw-text-[13px] tw-font-normal tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] textarea-wrapper"]),
                  onInput: () => {},
                  onFocusout: focusOut
                }, null, 42, _hoisted_18)), [
                  [_vModelText, form.value.templateDescription]
                ])
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "valid-message", "label", "label-tooltip"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-override-question-note-title-1",
            )), 1),
        _createVNode(BaseInput, {
          modelValue: form.value.templateNotes,
          "onUpdate:modelValue": [
            _cache[8] || (_cache[8] = ($event: any) => ((form.value.templateNotes) = $event)),
            _cache[9] || (_cache[9] = 
            (text) => {
              form.value.templateNotes = text;
              handleUpdateData();
            }
          )
          ],
          "class-name": `modal-edit-action-step-input !tw-mt-[0px] !tw-mb-[-7px]`,
          "label-class": `tw-mb-[10px] tw-text-[#231F20] tw-flex tw-items-center tw-h-[41px] sm:tw-mt-[18px]`,
          validation: _unref(v$).templateNotes,
          "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
          label: 
            _unref(getComponentUiText)('app-assessment-vendor-template-notes-title-1')
          ,
          "label-tooltip": 
            _unref(getComponentUiText)(
              'app-assessment-vendor-template-description-tooltip-1',
            )
          
        }, {
          default: _withCtx(() => [
            (__props.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21))
              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  id: `vendor-create-template-template-notes`,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((form.value.templateNotes) = $event)),
                    _cache[7] || (_cache[7] = 
              (text) => {
                form.value.templateNotes = text;
                handleUpdateData();
              }
            )
                  ],
                  placeholder: 
              _unref(getComponentUiText)(
                'app-assessment-vendor-template-notes-placeholder-1',
              )
            ,
                  style: `outline-color : #EFF0F1`,
                  "data-cy": "vendor-assess-template-notes-input",
                  class: _normalizeClass([isCallAPI.value && isUpdateTemplateNotes.value ? 'tw-pr-[50px]' : '', "tw-max-w-[800px] tw-placeholder-[#B7B7B7] auto-expand tw-min-h-[198px] tw-w-[100%] tw-text-[13px] tw-font-normal tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] textarea-wrapper"]),
                  onInput: () => {},
                  onFocusout: focusOut
                }, null, 42, _hoisted_22)), [
                  [_vModelText, form.value.templateNotes]
                ])
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "valid-message", "label", "label-tooltip"])
      ])
    ])
  ], 2))
}
}

})